var _defs, _rect, _path, _text, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2,.cls-3{fill:#54575a;}.cls-3{font-size:279.88px;font-family:Roboto-Bold, Roboto;font-weight:700;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.5,
    y: 25.5,
    width: 1149,
    height: 1149,
    rx: 95.94,
    ry: 95.94
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1078.56,35.5a86.26,86.26,0,0,1,85.94,85.94v957.11a86.26,86.26,0,0,1-85.94,85.94H121.44a86.26,86.26,0,0,1-85.94-85.94V121.44A86.26,86.26,0,0,1,121.44,35.5h957.11m0-20H121.44C63.17,15.5,15.5,63.18,15.5,121.44v957.11c0,58.27,47.67,105.94,105.94,105.94h957.11c58.27,0,105.94-47.68,105.94-105.94V121.44c0-58.27-47.68-105.94-105.94-105.94Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(106.92 376.03)"
  }, "T")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 283.5,
    y: 354.27,
    width: 809,
    height: 20.35,
    rx: 10.18,
    ry: 10.18
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 106.5,
    y: 492.82,
    width: 986,
    height: 20.35,
    rx: 10.18,
    ry: 10.18
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 106.5,
    y: 630.38,
    width: 986,
    height: 20.35,
    rx: 10.18,
    ry: 10.18
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 106.5,
    y: 768.05,
    width: 986,
    height: 20.35,
    rx: 10.18,
    ry: 10.18
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.5,
    y: 905.38,
    width: 986,
    height: 20.35,
    rx: 10.18,
    ry: 10.18
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 107.5,
    y: 1043.05,
    width: 986,
    height: 20.35,
    rx: 10.18,
    ry: 10.18
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/text.c31ed23000bd5c47cfd41c06af400b92.svg";
export { ForwardRef as ReactComponent };